<template>
  <summary-count title="Active Plans" :is-loading="isLoading" :count="activePlans" :change-count="changeCount" @cardClicked="gotoLink()" />
</template>

<script>
import SummaryCount from "@/views/business/dashboard/components/SummaryCount.vue";
import moment from "moment";

export default {
  name: "ActivePlans",
  components: {
    SummaryCount,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activePlans: 0,
      changeCount: 0,
      isLoading: false,
    };
  },
  computed: {
    startOfWeek() {
      return moment()
        .startOf("week")
        .toDate();
    },
    endOfWeek() {
      return moment()
        .endOf("week")
        .toDate();
    },
  },
  created() {
    this.loadPlans();
  },
  methods: {
    loadPlans() {
      this.isLoading = true;

      let url = `/businesses/${this.businessId}/dashboard/activeplans`;

      this.$axios
        .get(url, {
          params: {
            startOfWeek: this.startOfWeek,
            endOfWeek: this.endOfWeek,
          },
        })
        .then((res) => {
          this.activePlans = res.data.activePlans;
          this.changeCount = res.data.changeCount;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    gotoLink() {
      this.$router.push(`/businesses/${this.businessId}/members`);
    },
  },
};
</script>
